import React, { useState } from 'react';
import { FaArrowsAltH } from '@react-icons/all-files/fa/FaArrowsAltH';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import ServicioAsignadoTable from './ServicioAsignadoTable';
import ServicioAsignadoCrearModal from './ServicioAsignadoCrearModal';
import ServicioAsignadoEditarModal from './ServicioAsignadoEditarModal';
import { idServicioFromServicioPreciosRow } from './servicio-asignado-form';
import WindowHeader from '../../../commons/WindowHeader';
import { buildGrupoPanelTitle, type EmpresaGrupoResumen } from '../grupo-panel-title';

const ServicioAsignado = (props: {
    empresaServicios: any;
    grupoId?: string | null;
    empresaId?: string | null;
    empresaSeleccionada?: EmpresaGrupoResumen | null;
    proveedores?: any[];
    empresasGrupo?: any[];
    canEditGrupoEmpresas?: boolean;
    filaExpandida?: boolean;
    onToggleFilaExpandida?: () => void;
    onServicioAsignado?: () => void;
    onServicioEliminado?: () => void;
}) => {
    const {
        empresaServicios,
        grupoId,
        empresaId,
        empresaSeleccionada,
        proveedores = [],
        empresasGrupo = [],
        canEditGrupoEmpresas = false,
        filaExpandida = false,
        onToggleFilaExpandida,
        onServicioAsignado,
        onServicioEliminado,
    } = props;

    const [crearOpen, setCrearOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [editServicioId, setEditServicioId] = useState<number | null>(null);
    const [editListRow, setEditListRow] = useState<any>(null);

    const empresaIdNumerico =
        empresaId != null && empresaId !== 'new' ? Number(empresaId) : NaN;
    const empresaSeleccionadaActiva =
        empresaSeleccionada != null && !Number.isNaN(empresaIdNumerico);
    const panelTitle = buildGrupoPanelTitle(
        'Servicios Asignados',
        filaExpandida ? empresaSeleccionada : null,
    );

    const expandFilaButton =
        onToggleFilaExpandida != null ? (
            <button
                type="button"
                className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
                style={{ width: 36, height: 32, padding: 0 }}
                title={
                    filaExpandida
                        ? 'Restaurar ancho: mostrar de nuevo contactos junto a servicios'
                        : 'Expandir servicios al 100 % del ancho (ocultar contactos en esta fila)'
                }
                aria-label={
                    filaExpandida
                        ? 'Contraer panel de servicios asignados'
                        : 'Expandir panel de servicios asignados a ancho completo'
                }
                onClick={() => onToggleFilaExpandida()}
            >
                <FaArrowsAltH />
            </button>
        ) : null;

    const plusButton =
        empresaSeleccionadaActiva && grupoId != null && grupoId !== 'new' ? (
            <button
                type="button"
                className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
                style={{ width: 36, height: 32, padding: 0 }}
                disabled={!canEditGrupoEmpresas}
                title={
                    canEditGrupoEmpresas
                        ? 'Agregar servicio asignado'
                        : 'No tiene permiso para agregar servicios'
                }
                aria-label="Agregar servicio asignado"
                onClick={() => setCrearOpen(true)}
            >
                <FaPlus />
            </button>
        ) : null;

    const headerActions =
        expandFilaButton != null || plusButton != null ? (
            <div className="d-flex align-items-center gap-1 flex-shrink-0">
                {expandFilaButton}
                {plusButton}
            </div>
        ) : undefined;

    const empresaNombre = empresaSeleccionada?.razonSocial ?? undefined;

    const openEditarServicio = (row: any) => {
        const sid = idServicioFromServicioPreciosRow(row);
        if (sid == null) return;
        setCrearOpen(false);
        setEditServicioId(sid);
        setEditListRow(row);
        setEditOpen(true);
    };

    const tableEditHandler = canEditGrupoEmpresas ? openEditarServicio : undefined;

    return (
        <>
            <WindowHeader title={panelTitle} headerExtraRight={headerActions} />
            <ServicioAsignadoCrearModal
                open={crearOpen}
                grupoId={grupoId}
                empresaId={empresaId}
                empresaNombre={empresaNombre}
                proveedores={proveedores}
                empresasGrupo={empresasGrupo}
                onClose={() => setCrearOpen(false)}
                onCreated={onServicioAsignado}
            />
            <ServicioAsignadoEditarModal
                open={editOpen}
                servicioId={editServicioId}
                grupoId={grupoId}
                empresaId={empresaId}
                empresaNombre={empresaNombre}
                listRow={editListRow}
                proveedores={proveedores}
                empresasGrupo={empresasGrupo}
                onClose={() => {
                    setEditOpen(false);
                    setEditServicioId(null);
                    setEditListRow(null);
                }}
                onSaved={onServicioAsignado}
                onDeleted={onServicioEliminado}
            />
            <ServicioAsignadoTable
                empresaServicios={empresaServicios}
                onEditarServicio={tableEditHandler}
            />
        </>
    );
};

export default ServicioAsignado;
